import Content from './Content.vue'

export default Content
